import * as tslib_1 from "tslib";
import { AfterViewInit, ChangeDetectorRef, ElementRef, ErrorHandler, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatAutocompleteTrigger, MatDialog, MatTab, MatTabGroup } from '@angular/material';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { SearchFormType } from '../models/search-form-type.model';
import { SearchQuery } from '../models/search-query.model';
import { AirportFilterListComponent } from '../airport-filter-list/airport-filter-list.component';
import { AirportService } from '../../airport/airport.service';
import { GoogleService } from '../../google/google.service';
import { mergeStates, State } from '../../shared/state-view/state.model';
import { environment } from '../../../environments/environment';
import { AutocompleteOverlayComponent } from '../../shared/autocomplete-overlay/autocomplete-overlay.component';
import { browser } from '../../../browser';
import { AutocompleteOptionType, AutocompleteTriggerComponent, AutocompleteType } from '../../shared/autocomplete-trigger/autocomplete-trigger.component';
import { Source } from '../../shared/models/source.model';
import { WhatsnewComponent } from '../../whatsnew/whatsnew.component';
import { WhatsNewService } from '../../shared/services/whats-new.service';
import { EventFilterListComponent } from '../event-filter-list/event-filter-list.component';
import { AviationEventFiltersService } from '../../shared/services/aviation-event-filters.service';
// tslint:disable-next-line:max-line-length
import { FlyingClubFinderFilterListComponent } from '../flying-club-finder-filter-list/flying-club-finder-filter-list.component';
import { FlyingClubFinderFiltersService } from '../../shared/services/flying-club-finder-filters.service';
// tslint:disable-next-line:max-line-length
import { FlightSchoolFinderFilterListComponent } from '../flight-school-finder-filter-list/flight-school-finder-filter-list.component';
import { FlightSchoolFinderFiltersService } from '../../shared/services/flight-school-finder-filters.service';
// tslint:disable-next-line:max-line-length
import { UniversityFinderFilterListComponent } from '../university-finder-filter-list/university-finder-filter-list.component';
import { UniversityFinderFiltersService } from '../../shared/services/university-finder-filters.service';
// tslint:disable-next-line:max-line-length
import { FboFinderFilterListComponent } from '../fbo-finder-filter-list/fbo-finder-filter-list.component';
import { FboFinderFiltersService } from '../../shared/services/fbo-finder-filters.service';
// tslint:disable-next-line:max-line-length
import { ServiceRepairFinderFilterListComponent } from '../service-repair-finder-filter-list/service-repair-finder-filter-list.component';
import { ServiceRepairFinderFiltersService } from '../../shared/services/service-repair-finder-filters.service';
// tslint:disable-next-line:max-line-length
import { RentalSalesFinderFilterListComponent } from '../rental-sales-finder-filter-list/rental-sales-finder-filter-list.component';
import { RentalSalesFinderFiltersService } from '../../shared/services/rental-sales-finder-filters.service';
import { LatLon } from '../../util/geodesy/latlon';
import { AuthService } from '../../auth/auth/auth.service';
import { AnalyticsService } from '../../airport/service/google-analytics-4.service';
import { FuelFilterListComponent } from '../fuel-filter-list/fuel-filter-list.component';
import { FilterKeys } from '../filters/filters';
import { ShowDialogComponent } from '../../shared/show-dialog/show-dialog.component';
var LandingPageComponent = /** @class */ (function () {
    function LandingPageComponent(_router, _meta, _title, _airportService, _google, _errorHandler, _cdref, _matDialog, _whatsNewService, _aviationEventFiltersService, _flyingClubFinderFiltersService, _flightSchoolFinderFiltersService, _universityFinderFiltersService, _fboFinderFiltersService, _serviceRepairFinderFiltersService, _rentalSalesFinderFiltersService, _route, _auth, _analyticsService) {
        this._router = _router;
        this._meta = _meta;
        this._title = _title;
        this._airportService = _airportService;
        this._google = _google;
        this._errorHandler = _errorHandler;
        this._cdref = _cdref;
        this._matDialog = _matDialog;
        this._whatsNewService = _whatsNewService;
        this._aviationEventFiltersService = _aviationEventFiltersService;
        this._flyingClubFinderFiltersService = _flyingClubFinderFiltersService;
        this._flightSchoolFinderFiltersService = _flightSchoolFinderFiltersService;
        this._universityFinderFiltersService = _universityFinderFiltersService;
        this._fboFinderFiltersService = _fboFinderFiltersService;
        this._serviceRepairFinderFiltersService = _serviceRepairFinderFiltersService;
        this._rentalSalesFinderFiltersService = _rentalSalesFinderFiltersService;
        this._route = _route;
        this._auth = _auth;
        this._analyticsService = _analyticsService;
        this.query = new SearchQuery();
        this.form = new FormGroup({
            wrapper: new FormGroup({
                type: new FormControl(),
                query: new FormControl(),
                usOrInternational: new FormControl()
            })
        });
        this.State = State;
        this.SearchFormType = SearchFormType;
        this.numAirportFiltersSelected = 0;
        this.airportSearchState = State.Empty;
        this.locationState = State.Empty;
        this.videoOverlayActive = false;
        this._title.setTitle(environment.appName);
        this._meta.updateTag({
            name: 'description',
            content: 'AOPA Airports is an online database of thousands of public- and private-use airports. '
                + 'Airport listings include airport diagrams, fuel prices, and more.'
        });
        // This allows the jump to anchor tag to favorites from the airport details page.
        // Ugly.  Hopefully some day they will fix this: https://github.com/angular/angular/issues/6595
        _router.events.subscribe(function (s) {
            if (s instanceof NavigationEnd) {
                var tree = _router.parseUrl(_router.url);
                if (tree.fragment) {
                    var element = document.querySelector('#' + tree.fragment);
                    if (element) {
                        element.scrollIntoView(true);
                    }
                }
            }
        });
    }
    Object.defineProperty(LandingPageComponent.prototype, "queryCtrl", {
        get: function () {
            return this.form.get('wrapper').get('query');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LandingPageComponent.prototype, "queryLabel", {
        get: function () {
            if (this.query.type === SearchFormType.Activities) {
                return 'Location';
            }
            else if (this.query.type === SearchFormType.AviationEvents) {
                if (this.isInternational) {
                    return 'Location';
                }
                else {
                    return 'Location (optional)';
                }
            }
            else if (this.query.type === SearchFormType.FlyingClubs) {
                return 'Location';
            }
            else if (this.query.type === SearchFormType.FlightSchools) {
                return 'Location';
            }
            else if (this.query.type === SearchFormType.Universities) {
                return 'Location (optional)';
            }
            else if (this.query.type === SearchFormType.Fbos) {
                return 'Location';
            }
            else if (this.query.type === SearchFormType.ServiceRepair) {
                return 'Location';
            }
            else if (this.query.type === SearchFormType.RentalSales) {
                return 'Location';
            }
            else {
                return 'Airport ID, Name, City, or State';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LandingPageComponent.prototype, "searchPlaceholder", {
        get: function () {
            if (this.query.type === SearchFormType.Activities) {
                return 'Search by City Name';
            }
            else if (this.query.type === SearchFormType.AviationEvents) {
                if (this.isInternational) {
                    return 'City or Country Name';
                }
                else {
                    return 'Airport ID, Airport Name, State Name';
                }
            }
            else if (this.query.type === SearchFormType.FlyingClubs) {
                return 'Airport ID, ZIP, City, or State';
            }
            else if (this.query.type === SearchFormType.FlightSchools) {
                return 'Airport ID, ZIP, City, or State';
            }
            else if (this.query.type === SearchFormType.Universities) {
                return 'Airport ID, ZIP, City, or State';
            }
            else if (this.query.type === SearchFormType.Fbos) {
                return 'Airport ID, ZIP, City, or State';
            }
            else if (this.query.type === SearchFormType.ServiceRepair) {
                return 'Airport ID, ZIP, City, or State';
            }
            else if (this.query.type === SearchFormType.RentalSales) {
                return 'Airport ID, ZIP, City, or State';
            }
            else {
                return 'Search';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LandingPageComponent.prototype, "queryType", {
        get: function () {
            return (this.query.type === SearchFormType.Activities)
                ? AutocompleteType.Google
                : AutocompleteType.Combined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LandingPageComponent.prototype, "valid", {
        get: function () {
            return this.query.validate().valid;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LandingPageComponent.prototype, "validationReason", {
        get: function () {
            var result = this.query.validate();
            if (!result.valid) {
                if (this.query.type === SearchFormType.FlyingClubs || this.query.type === SearchFormType.FlightSchools
                    || this.query.type === SearchFormType.Universities || this.query.type === SearchFormType.Fbos
                    || this.query.type === SearchFormType.ServiceRepair || this.query.type === SearchFormType.RentalSales) {
                    return 'Please enter an ICAO or FAA airport identifier, a 5-digit ZIP code, city, or state.';
                }
                return result.message || 'The query you entered is not valid.';
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LandingPageComponent.prototype, "searchState", {
        get: function () {
            return mergeStates(this.airportSearchState, this.locationState);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LandingPageComponent.prototype, "searchErrorMsg", {
        get: function () {
            if (this.airportSearchState === State.Error) {
                return 'An error occurred searching for airports or locations. Please try again later.';
            }
            if (this.locationState === State.Error) {
                return 'An error occurred resolving the location latitude and longitude. Please try again later.';
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LandingPageComponent.prototype, "isInternational", {
        get: function () {
            return this.form.get('wrapper').get('usOrInternational').value === 'International';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LandingPageComponent.prototype, "currentSearchTab", {
        get: function () {
            return this.query.type;
        },
        enumerable: true,
        configurable: true
    });
    LandingPageComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.aviationEventFilterSubscription = this._aviationEventFiltersService.aviationEventFilter.subscribe(function (ae) {
            _this.aviationEventFilter = ae;
        });
        this.flyingClubFinderFilterSubscription = this._flyingClubFinderFiltersService.flyingClubFinderFilter.subscribe(function (f) {
            _this.flyingClubFinderFilter = f;
        });
        this.flightSchoolFinderFilterSubscription = this._flightSchoolFinderFiltersService.flightSchoolFinderFilter.subscribe(function (f) {
            _this.flightSchoolFinderFilter = f;
        });
        this.universityFinderFilterSubscription = this._universityFinderFiltersService.universityFinderFilter.subscribe(function (f) {
            _this.universityFinderFilter = f;
        });
        this.fboFinderFilterSubscription = this._fboFinderFiltersService.fboFinderFilter.subscribe(function (f) {
            _this.fboFinderFilter = f;
        });
        this.serviceRepairFinderFilterSubscription = this._serviceRepairFinderFiltersService.serviceRepairFinderFilter.subscribe(function (f) {
            _this.serviceRepairFinderFilter = f;
        });
        this.rentalSalesFinderFilterSubscription = this._rentalSalesFinderFiltersService.rentalSalesFinderFilter.subscribe(function (f) {
            _this.rentalSalesFinderFilter = f;
        });
    };
    LandingPageComponent.prototype.ngAfterViewInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var showWhatsNew, dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setTimeout(function () {
                            // Workaround to prevent the invisible autocomplete menu overlay element from interfering with pointer
                            // interactions.
                            _this.onQueryBlur();
                            // Store the initially selected tab.
                            _this.selectedTab = _this._getSelectedTab();
                            // Get the number of initially selected filters
                            _this.numAirportFiltersSelected = _this.airportFilters.getNumSelected();
                            setTimeout(function () {
                                if (_this._route.snapshot.queryParamMap.has('t')) {
                                    if (_this._route.snapshot.queryParamMap.get('t') === 'activities') {
                                        _this.query.type = SearchFormType.Activities;
                                    }
                                    if (_this._route.snapshot.queryParamMap.get('t') === 'events') {
                                        _this.query.type = SearchFormType.AviationEvents;
                                    }
                                    if (_this._route.snapshot.queryParamMap.get('t') === 'flyingclubs') {
                                        _this.query.type = SearchFormType.FlyingClubs;
                                    }
                                    if (_this._route.snapshot.queryParamMap.get('t') === 'flightschools') {
                                        _this.query.type = SearchFormType.FlightSchools;
                                    }
                                    if (_this._route.snapshot.queryParamMap.get('t') === 'universities') {
                                        _this.query.type = SearchFormType.Universities;
                                    }
                                    if (_this._route.snapshot.queryParamMap.get('t') === 'fbos') {
                                        _this.query.type = SearchFormType.Fbos;
                                    }
                                    if (_this._route.snapshot.queryParamMap.get('t') === 'servicerepair') {
                                        _this.query.type = SearchFormType.ServiceRepair;
                                    }
                                    if (_this._route.snapshot.queryParamMap.get('t') === 'rentalsales') {
                                        _this.query.type = SearchFormType.RentalSales;
                                    }
                                    if (_this._route.snapshot.queryParamMap.get('t') === 'fuel') {
                                        _this.query.type = SearchFormType.FuelPrice;
                                    }
                                }
                            }, 300);
                        }, 100);
                        return [4 /*yield*/, this._whatsNewService.shouldShowWhatsNew()];
                    case 1:
                        showWhatsNew = _a.sent();
                        if (showWhatsNew) {
                            dialogRef = this._matDialog.open(WhatsnewComponent);
                            dialogRef.afterClosed().subscribe(function (result) {
                                _this._whatsNewService.displayedWhatsNew();
                            });
                        }
                        /* this.aviationEventFilterSubscription = this._aviationEventFiltersService.aviationEventFilter.subscribe(ae => {
                          this.aviationEventFilter = ae;
                        }); */
                        this._analyticsService.pageView('airport_landingpage', 'Airport/Event Landing Page');
                        return [2 /*return*/];
                }
            });
        });
    };
    LandingPageComponent.prototype.ngOnDestroy = function () {
        this.aviationEventFilterSubscription.unsubscribe();
        if (this.flyingClubFinderFilterSubscription) {
            this.flyingClubFinderFilterSubscription.unsubscribe();
        }
        if (this.flightSchoolFinderFilterSubscription) {
            this.flightSchoolFinderFilterSubscription.unsubscribe();
        }
        if (this.universityFinderFilterSubscription) {
            this.universityFinderFilterSubscription.unsubscribe();
        }
        if (this.fboFinderFilterSubscription) {
            this.fboFinderFilterSubscription.unsubscribe();
        }
        if (this.serviceRepairFinderFilterSubscription) {
            this.serviceRepairFinderFilterSubscription.unsubscribe();
        }
        if (this.rentalSalesFinderFilterSubscription) {
            this.rentalSalesFinderFilterSubscription.unsubscribe();
        }
    };
    LandingPageComponent.prototype.changeQueryParams = function () {
        var queryType = SearchFormType.Airports;
        if (this.query.type === SearchFormType.AviationEvents) {
            queryType = SearchFormType.AviationEvents;
            if (this.fuelFilters && this.fuelFilters.fuel100LLFilter) {
                this.fuelFilters.filterComponents.filter(function (c) { return c.filter.enabled; }).forEach(function (filt) {
                    if (filt.filter.key !== FilterKeys.PublicUse) {
                        filt.filter.enabled = false;
                    }
                });
            }
        }
        else if (this.query.type === SearchFormType.Activities) {
            queryType = SearchFormType.Activities;
            if (this.fuelFilters && this.fuelFilters.fuel100LLFilter) {
                this.fuelFilters.filterComponents.filter(function (c) { return c.filter.enabled; }).forEach(function (filt) {
                    if (filt.filter.key !== FilterKeys.PublicUse) {
                        filt.filter.enabled = false;
                    }
                });
            }
        }
        else if (this.query.type === SearchFormType.FlyingClubs) {
            queryType = SearchFormType.FlyingClubs;
        }
        else if (this.query.type === SearchFormType.FlightSchools) {
            queryType = SearchFormType.FlightSchools;
        }
        else if (this.query.type === SearchFormType.Universities) {
            queryType = SearchFormType.Universities;
        }
        else if (this.query.type === SearchFormType.Fbos) {
            queryType = SearchFormType.Fbos;
        }
        else if (this.query.type === SearchFormType.ServiceRepair) {
            queryType = SearchFormType.ServiceRepair;
        }
        else if (this.query.type === SearchFormType.RentalSales) {
            queryType = SearchFormType.RentalSales;
        }
        else if (this.query.type === SearchFormType.FuelPrice) {
            queryType = SearchFormType.FuelPrice;
            if (this.airportFilters && this.airportFilters.fuel100LLFilter) {
                this.airportFilters.filterComponents.filter(function (c) { return c.filter.enabled; }).forEach(function (filt) {
                    if (filt.filter.key !== FilterKeys.PublicUse) {
                        filt.filter.enabled = false;
                    }
                });
                // this.airportFilters.fuel100LLFilter.enabled = true;
            }
        }
        else {
            queryType = SearchFormType.Airports;
            if (this.fuelFilters && this.fuelFilters.fuel100LLFilter) {
                this.fuelFilters.filterComponents.filter(function (c) { return c.filter.enabled; }).forEach(function (filt) {
                    if (filt.filter.key !== FilterKeys.PublicUse) {
                        filt.filter.enabled = false;
                    }
                });
                /* this.fuelFilters.fuel100LLFilter.enabled = false;
                this.fuelFilters.fuelJetAFilter.enabled = false;
                this.fuelFilters.fuelMOGASFilter.enabled = false;
                this.fuelFilters.fuelUL94Filter.enabled = false; */
            }
        }
        var queryParams = { 't': queryType };
        this._router.navigate([], {
            relativeTo: this._route,
            queryParams: queryParams,
            queryParamsHandling: 'merge',
        });
    };
    LandingPageComponent.prototype.onSelectTab = function (event) {
        this.selectedTab = event.tab;
    };
    LandingPageComponent.prototype._getSelectedTab = function () {
        var _this = this;
        if (!this.tabGroup._tabs) {
            return null;
        }
        return this.tabGroup._tabs
            .toArray()
            .find(function (tab, i) { return i === _this.tabGroup.selectedIndex; });
    };
    LandingPageComponent.prototype.onSubmit = function () {
        if (this.query.type === SearchFormType.AviationEvents) {
            this.query.aviationEventsFilter = this.aviationEventFilter;
            this.query.radius = 500;
        }
        if (this.query.type === SearchFormType.FlyingClubs) {
            this.query.flyingClubFinderFilter = this.flyingClubFinderFilter;
            this.query.radius = this.query.radius || 50;
        }
        if (this.query.type === SearchFormType.FlightSchools) {
            this.query.flightSchoolFinderFilter = this.flightSchoolFinderFilter;
            this.query.radius = this.query.radius || 50;
        }
        if (this.query.type === SearchFormType.Universities) {
            this.query.universityFinderFilter = this.universityFinderFilter;
            this.query.radius = this.query.radius || 50;
        }
        if (this.query.type === SearchFormType.Fbos) {
            this.query.fboFinderFilter = this.fboFinderFilter;
            this.query.radius = this.query.radius || 50;
        }
        if (this.query.type === SearchFormType.ServiceRepair) {
            this.query.serviceRepairFinderFilter = this.serviceRepairFinderFilter;
            this.query.radius = this.query.radius || 50;
        }
        if (this.query.type === SearchFormType.RentalSales) {
            this.query.rentalSalesFinderFilter = this.rentalSalesFinderFilter;
            this.query.radius = this.query.radius || 50;
        }
        this.acTrigger.submit(this.query);
    };
    LandingPageComponent.prototype.onClickAdvancedSearch = function () {
        if (this.query.type === SearchFormType.AviationEvents) {
            this.query.aviationEventsFilter = this.aviationEventFilter;
            this.acTrigger.submit(this.query);
            // this._router.navigate(['/search'], { queryParams: {'t': 'events', 'public': 1} });
        }
        else {
            this._router.navigate(['/search'], { queryParams: { 'public': 1 } });
        }
    };
    LandingPageComponent.prototype.onItemSelected = function (e) {
        switch (e.type) {
            case AutocompleteOptionType.Airport:
                if (this.query.type === SearchFormType.AviationEvents) {
                    this.query.term = e.airport.identifier;
                    this.query.location = new LatLon(e.airport.location.lat, e.airport.location.lon);
                    this.query.radius = 50;
                    this.query.aviationEventsFilter = this.aviationEventFilter;
                    var params_1 = this.query.encode();
                    this._router.navigate(['/search'], { queryParams: params_1 });
                }
                else if (this.query.type === SearchFormType.FlyingClubs) {
                    this.query.term = '';
                    this.query.locationDescription = e.airport.identifier || '';
                    this.query.location = new LatLon(e.airport.location.lat, e.airport.location.lon);
                    this.query.radius = this.query.radius || 50;
                    this.query.flyingClubFinderFilter = this.flyingClubFinderFilter;
                    var params_2 = this.query.encode();
                    this._router.navigate(['/search'], { queryParams: params_2 });
                }
                else if (this.query.type === SearchFormType.FlightSchools) {
                    this.query.term = '';
                    this.query.locationDescription = e.airport.identifier || '';
                    this.query.location = new LatLon(e.airport.location.lat, e.airport.location.lon);
                    this.query.radius = this.query.radius || 50;
                    this.query.flightSchoolFinderFilter = this.flightSchoolFinderFilter;
                    var params_3 = this.query.encode();
                    this._router.navigate(['/search'], { queryParams: params_3 });
                }
                else if (this.query.type === SearchFormType.Universities) {
                    this.query.term = '';
                    this.query.locationDescription = e.airport.identifier || '';
                    this.query.location = new LatLon(e.airport.location.lat, e.airport.location.lon);
                    this.query.radius = this.query.radius || 50;
                    this.query.universityFinderFilter = this.universityFinderFilter;
                    var params_4 = this.query.encode();
                    this._router.navigate(['/search'], { queryParams: params_4 });
                }
                else if (this.query.type === SearchFormType.Fbos) {
                    this.query.term = '';
                    this.query.locationDescription = e.airport.identifier || '';
                    this.query.location = new LatLon(e.airport.location.lat, e.airport.location.lon);
                    this.query.radius = this.query.radius || 50;
                    this.query.fboFinderFilter = this.fboFinderFilter;
                    var params_5 = this.query.encode();
                    this._router.navigate(['/search'], { queryParams: params_5 });
                }
                else if (this.query.type === SearchFormType.ServiceRepair) {
                    this.query.term = '';
                    this.query.locationDescription = e.airport.identifier || '';
                    this.query.location = new LatLon(e.airport.location.lat, e.airport.location.lon);
                    this.query.radius = this.query.radius || 50;
                    this.query.serviceRepairFinderFilter = this.serviceRepairFinderFilter;
                    var params_6 = this.query.encode();
                    this._router.navigate(['/search'], { queryParams: params_6 });
                }
                else if (this.query.type === SearchFormType.RentalSales) {
                    this.query.term = '';
                    this.query.locationDescription = e.airport.identifier || '';
                    this.query.location = new LatLon(e.airport.location.lat, e.airport.location.lon);
                    this.query.radius = this.query.radius || 50;
                    this.query.rentalSalesFinderFilter = this.rentalSalesFinderFilter;
                    var params_7 = this.query.encode();
                    this._router.navigate(['/search'], { queryParams: params_7 });
                }
                else if (this.query.type === SearchFormType.FuelPrice) {
                    this.query.term = '';
                    this.query.locationDescription = e.airport.identifier || '';
                    this.query.location = new LatLon(e.airport.location.lat, e.airport.location.lon);
                    this.query.radius = 50;
                    var params_8 = this.query.encode();
                    this._router.navigate(['/search'], { queryParams: params_8 });
                }
                else {
                    if (e.airport.sourceId === Source.CaribbeanGuide || e.airport.sourceId === Source.BahamasGuide) {
                        this._router.navigate(['/airports', e.airport.identifier, 'island']);
                    }
                    else {
                        this._router.navigate(['/airports', e.airport.identifier]);
                    }
                }
                return;
            case AutocompleteOptionType.Location:
                this.queryFieldEl.nativeElement.value = e.location.description;
                this._resolveLocation(e.location.place_id, e.location.description);
                break;
            case AutocompleteOptionType.State:
                this.queryFieldEl.nativeElement.value = e.state.name;
                this.query.term = '';
                this.query.locationDescription = e.state.name;
                this.query.state = e.state.stateCode;
                break;
            case AutocompleteOptionType.ZipCode: {
                // A ZIP entry stays a finder search (Flying Clubs / Flight Schools): the API resolves the ZIP
                // centroid from the WebApps ZIPCodes table and runs a radius search. Keep query.type rather than
                // forcing Airports.
                this.query.term = e.query;
                this.query.location = null;
                this.query.bounds = null;
                this.query.state = null;
                this.query.flyingClubFinderFilter = this.flyingClubFinderFilter;
                this.query.flightSchoolFinderFilter = this.flightSchoolFinderFilter;
                this.query.universityFinderFilter = this.universityFinderFilter;
                this.query.fboFinderFilter = this.fboFinderFilter;
                this.query.serviceRepairFinderFilter = this.serviceRepairFinderFilter;
                this.query.rentalSalesFinderFilter = this.rentalSalesFinderFilter;
                var zipParams = this.query.encode();
                this._router.navigate(['/search'], { queryParams: zipParams });
                return;
            }
            default:
                this.query.type = SearchFormType.Airports;
                this.query.term = e.query;
                var params = this.query.encode();
                this._router.navigate(['/search'], { queryParams: params });
        }
    };
    LandingPageComponent.prototype.onAirportFiltersChanged = function () {
        this.numAirportFiltersSelected = this.airportFilters.getNumSelected();
    };
    LandingPageComponent.prototype.onFuelFiltersChanged = function () {
        this.numAirportFiltersSelected = this.fuelFilters.getNumSelected();
    };
    LandingPageComponent.prototype.onQueryKeyPress = function () {
        var _this = this;
        setTimeout(function () {
            _this.query.term = _this.queryCtrl.value;
            if (_this.queryCtrl && _this.queryCtrl.value && _this.queryCtrl.value.length < 1) {
                _this.query.term = '';
            }
        }, 0);
    };
    LandingPageComponent.prototype.onQueryFocus = function (e) {
        if (browser && (browser.os === 'iOS' || browser.os === 'Android OS')) {
            // Angular Material's autocomplete component is not really usable on mobile:
            // https://github.com/angular/material2/issues/6341
            // Instead, pop up a full-screen overlay with a search box and a filtered list of suggestions
            e.preventDefault();
            this.acOverlay.show();
            this._cdref.detectChanges();
            this.acOverlay.focus();
        }
    };
    LandingPageComponent.prototype.onQueryBlur = function () {
        var _this = this;
        // Workaround to prevent the invisible autocomplete menu overlay element from interfering with pointer interactions.
        setTimeout(function () { return _this.acInputTrigger.closePanel(); }, 300);
    };
    LandingPageComponent.prototype.onQueryTypeChanged = function (event) {
        this.changeQueryParams();
        this.tabGroup.selectedIndex = 1;
    };
    LandingPageComponent.prototype.enableForm = function () {
        this.setEnabledState(true);
    };
    LandingPageComponent.prototype.disableForm = function () {
        this.setEnabledState(false);
    };
    LandingPageComponent.prototype.setEnabledState = function (enabled) {
        this.wrapper.nativeElement.disabled = !enabled;
    };
    LandingPageComponent.prototype._resolveLocation = function (placeId, description) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var location_1, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.locationState = State.Loading;
                        this.disableForm();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this._google.geocodePlace(placeId)];
                    case 2:
                        location_1 = _a.sent();
                        this.query.term = '';
                        this.query.location = location_1;
                        this.query.locationDescription = description || '';
                        this.query.radius = this.query.radius || 50;
                        this.locationState = State.Content;
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        this._errorHandler.handleError(e_1);
                        this.locationState = State.Error;
                        return [3 /*break*/, 5];
                    case 4:
                        this.enableForm();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    LandingPageComponent.prototype.openVideoOverlay = function () {
        this.videoOverlayActive = true;
    };
    LandingPageComponent.prototype.closeVideoOverlay = function () {
        this.videoOverlayActive = false;
    };
    LandingPageComponent.prototype.addEventFormClick = function () {
        if (!this._auth.authenticated || !this._auth.endUser) {
            this._auth.redirectToLogin();
            return;
        }
        this._router.navigate(['/addevent']);
    };
    LandingPageComponent.prototype.onClickFavorite = function (favoriteType) {
        // Switch tabs if trying to show favorites of a different tab type
        if (this.query.type !== SearchFormType.Airports && favoriteType === 'airports') {
            this.query.type = SearchFormType.Airports;
            this.changeQueryParams();
            // Delay to allow for switching tabs if tab switch required
            setTimeout(function () {
                var element = document.querySelector('#favorites');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 400);
        }
        else if (this.query.type !== SearchFormType.AviationEvents && favoriteType === 'events') {
            this.query.type = SearchFormType.AviationEvents;
            this.changeQueryParams();
            // Delay to allow for switching tabs if tab switch required
            setTimeout(function () {
                var element = document.querySelector('#favorites');
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 400);
        }
        else {
            var element = document.querySelector('#favorites');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    };
    LandingPageComponent.prototype.clickUsorInternational = function (event) {
        if (event.value === 'International') {
            this.aviationEventFilter.international = true;
        }
        else {
            this.aviationEventFilter.international = false;
        }
        this.query.aviationEventsFilter = this.aviationEventFilter;
    };
    LandingPageComponent.prototype.onClickFuelLearnMore = function () {
        var dialogRef = this._matDialog.open(ShowDialogComponent);
    };
    return LandingPageComponent;
}());
export { LandingPageComponent };
